import Immutable from 'seamless-immutable';

export const insertUpdatedItem = (items, updatedItem) =>
  items.map((item) => (item.id === updatedItem.id ? Immutable(updatedItem) : item));
